export default "__VITE_ASSET__2e577c19__"